import '../globalLibrariesMinimal';

import AvatarWrapper from '../components/AvatarWrapper';
import ReactComponentMounter from '../utils/react-component-mounter';

import Microfrontend from '../apps/Microfrontend';

ReactComponentMounter.register({
  Microfrontend,
  AvatarWrapper
});
